import { Injectable } from '@angular/core';
import { JsonStorageTranscoder } from './storage-transcoders';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  public has(key: string): boolean {
    return this.storage.getItem(key) !== null;
  }

  public remove(key: string): void {
    this.storage.removeItem(key);
  }

  public clear(): void {
    this.storage.clear();
  }

  public getItem<T>(key: string): T | undefined {
    const value = this.storage.getItem(key);
    return value != null ? JsonStorageTranscoder.decode(value) : undefined;
  }

  public setItem<T>(key: string, value: T): void {
    const stringValue = JsonStorageTranscoder.encode(value);
    return this.storage.setItem(key, stringValue);
  }

  private get storage(): Storage {
    return window.localStorage;
  }
}
